export default {
    install(Vue, options) {
        Vue.config.globalProperties.$numAbbr = function (number, decimals = 0) {
            if (isNaN(number)) {
                return number; // Return original value if it's not a number
            }

            let absNumber = Math.abs(number); // Get the absolute value of the number
            let abbrev = ["", "K", "M", "B", "T"]; // Adjusted to include empty string for numbers < 1000

            let i = 0;
            while (i < abbrev.length - 1 && absNumber >= 1000) {
                absNumber /= 1000;
                i++;
            }

            let result = Math.round(absNumber * Math.pow(10, decimals)) / Math.pow(10, decimals);

            // Add the negative sign back in
            if (number < 0) {
                result = -result;
            }

            return result + abbrev[i];
        }
    }
}
